import React from 'react';

export const AmountField = ({ record = {} }: any) => (
  <span>{record.amount?.toFixed(2) / 100}€</span>
);
